<section class="validation-error-panel">
  <mat-tab-group class="validation-error-tabs blue-line-minimal-tabs sidebar-tabs" animationDuration="0ms"
    [class.single-tab]="visibleTabs.length === 1"
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="onTabIndexChange($event)">
    <mat-tab *ngFor="let tab of visibleTabs" [label]="tabLabel(tab)">
      <ng-container *ngTemplateOutlet="errorPanel"></ng-container>
    </mat-tab>
  </mat-tab-group>
</section>

<ng-template #errorPanel>
  <header class="validation-error-header">
    <div class="validation-error-actions">
      <button mat-raised-button type="button" [disabled]="isLoading" (click)="refresh()" class="regenerate-btn">
        <mat-icon [class.spin]="isLoading">refresh</mat-icon>
        <span *ngIf="!isLoading && !hasGenerated">Generate</span>
        <span *ngIf="!isLoading && hasGenerated">Regenerate</span>
        <span *ngIf="isLoading && !hasGenerated">Generating...</span>
        <span *ngIf="isLoading && hasGenerated">Regenerating...</span>
      </button>
      <button mat-raised-button type="button" [disabled]="isLoading || isDownloading || !hasValidationErrors"
        (click)="downloadValidationErrors()" class="regenerate-btn download-btn"
        [class.is-downloading]="isDownloading">
        <span class="download-icon-wrap">
          <mat-icon class="download-icon-base">download</mat-icon>
          <mat-icon class="download-icon-arrow">arrow_downward</mat-icon>
        </span>
        <span>{{ isDownloading ? 'Downloading...' : 'Download' }}</span>
      </button>
    </div>
  </header>

  <div class="validation-error-status validation-error-status--info" *ngIf="isReadyToValidate">
    <div class="validation-error-status-icon-wrap">
      <mat-icon class="validation-error-status-icon">fact_check</mat-icon>
    </div>
    <p class="validation-error-status-title">Validate this form</p>
    <p class="validation-error-status-sub">
      Click <strong>Generate</strong> to check this form against all schema rules before submitting.
    </p>
  </div>

  <div class="validation-error-status validation-error-status--warning" *ngIf="hasMappingIssue">
    <div class="validation-error-status-icon-wrap">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.44 43.75">
        <defs>
          <style>
            .cls-1 { fill: #ced7db; }
            .cls-2 { fill: #ebeef0; }
            .cls-3 { fill: #8a97a5; }
            .cls-4 { fill: #5485e4; }
            .cls-5 { fill: #5e93fe; }
            .cls-6 { fill: #5e94fe; }
          </style>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path class="cls-1"
              d="M17.73,43.74H5.94A5.81,5.81,0,0,1,0,37.84c.11-10.67.08-21.35,0-32A5.72,5.72,0,0,1,5.84,0c4,0,7.93,0,11.89,0a2,2,0,0,1,.33,1.53c-.07,4,0,8,0,12a22.84,22.84,0,0,0,.12,2.74c0,.2-.2.28-.37.34-1,.38-1.27.65-1.28,1.72,0,3.07,0,6.14,0,9.21a2,2,0,0,0,1.22,1.87c.44.66.27,1.45.44,2.16a.64.64,0,0,1-.38.26,1.41,1.41,0,0,0-1.3,1.57c0,.73,0,1.46,0,2.18a1.69,1.69,0,0,0,1,1.77,1.12,1.12,0,0,1,.45.49A34.09,34.09,0,0,1,18,43.06,1,1,0,0,1,17.73,43.74Z" />
            <path class="cls-2"
              d="M17.73,43.74V37.66c1.82-1.27,1.21-3.13,1.17-4.84,0-.54-.61-.8-.79-1.27-.69-.58-.27-1.36-.37-2a1.09,1.09,0,0,0,.08-.15A2.26,2.26,0,0,0,19,27.07c-.05-2.52,0-5,0-7.56a4.25,4.25,0,0,0-.86-3.18c-.48-.28-.38-.75-.38-1.18q0-7.56,0-15.14a5.36,5.36,0,0,1,4,1.36c-.31.29-.71.22-1.08.26a2.06,2.06,0,0,0-2,2.1c-.05,2.15-.07,4.31,0,6.46a5,5,0,0,0,4.84,4.72c2.54.05,5.07,0,7.61,0a2.16,2.16,0,0,0,2.35-2.46c0-.34-.14-.7.06-1a4.4,4.4,0,0,1,1.93,3.62c.05,7.83,0,15.65,0,23.48a5.46,5.46,0,0,1-3.69,4.83,7,7,0,0,1-2.32.39C25.52,43.73,21.63,43.74,17.73,43.74Z" />
            <path class="cls-3"
              d="M33.48,11.43a2.65,2.65,0,0,1-2.72,3.85c-2.31-.15-4.63,0-6.94,0a5.41,5.41,0,0,1-5.53-5.52c0-1.75.1-3.5,0-5.23-.17-2.31,1.32-3.57,3.46-3.12C24.06,3.11,26.19,5.11,28.41,7,30.12,8.44,31.89,9.84,33.48,11.43Z" />
            <path class="cls-4"
              d="M17.75,29.51c-1.17-.26-1.53-.67-1.53-1.78,0-3.22,0-6.43,0-9.65,0-1.15.44-1.63,1.52-1.72a1.7,1.7,0,0,1,.32,1.25c0,3.53,0,7.07,0,10.6a1.61,1.61,0,0,1-.33,1.25Z" />
            <path class="cls-5"
              d="M17.73,29.46q0-6.55,0-13.1l.38,0a1.67,1.67,0,0,1,1.15,1.77c0,3.2,0,6.4,0,9.6C19.26,28.85,18.86,29.28,17.73,29.46Z" />
            <path class="cls-6"
              d="M18.12,31.55a1.62,1.62,0,0,1,1.15,1.73c0,.76,0,1.51,0,2.26,0,1.33-.26,1.69-1.52,2.12l-.4-.17c.15-1.52.06-3,.09-4.56a1.85,1.85,0,0,1,.31-1.35Z" />
            <path class="cls-4"
              d="M17.74,31.58v5.09c0,.33.1.73-.4.82A1.39,1.39,0,0,1,16.22,36c0-1,0-1.9,0-2.85A1.42,1.42,0,0,1,17.74,31.58Z" />
          </g>
        </g>
      </svg>
    </div>
    <p class="validation-error-status-title">We ran into a problem validating this form</p>
    <p class="validation-error-status-sub" *ngIf="!mappingTicketDisplayId">
      Something unexpected happened while reading your workbook data. This is usually caused by an issue importing data
      from the GMT Calculator.
      <br />
      If the problem persists, please contact our support team.
    </p>
    <p class="validation-error-status-sub" *ngIf="mappingTicketDisplayId">
      Something unexpected happened while reading your workbook data. This is usually caused by an issue importing data
      from the GMT Calculator.
      <br />
      Your support ticket has been created — a member of our team will follow up with you shortly.
    </p>

    <div class="validation-error-ticket-block" *ngIf="mappingTicketDisplayId">
      <div class="validation-error-ticket">
        <span class="validation-error-ticket-label">Support ticket</span>
        <a class="validation-error-ticket-link" *ngIf="mappingTicketUrl; else ticketIdOnly" [href]="mappingTicketUrl"
          target="_blank" rel="noopener">
          {{ mappingTicketDisplayId }}
          <mat-icon class="validation-error-ticket-icon">open_in_new</mat-icon>
        </a>
        <ng-template #ticketIdOnly>
          <span class="validation-error-ticket-id">{{ mappingTicketDisplayId }}</span>
        </ng-template>
      </div>
    </div>

    <div class="validation-error-ticket-block" *ngIf="!mappingTicketDisplayId">
      <button mat-button color="primary" type="button" class="validation-error-create-ticket-btn action-button"
        (click)="openCreateSupportTicketDialog()">
        <span>Open a Support Ticket</span>
      </button>
    </div>
  </div>

  <div class="validation-error-table-wrapper" *ngIf="hasValidationErrors">
    <table class="validation-error-table">
      <thead>
        <tr>
          <th class="col-id">ID</th>
          <th class="col-type">Type</th>
          <th class="col-cell">Cell</th>
          <th class="col-message">Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of validationErrors; trackBy: trackByError"
          (click)="onRowClick(error)"
          class="validation-error-row-clickable">
          <td class="col-id">{{ error.errorSequenceId }}</td>
          <td class="col-type">
            <span class="validation-error-type" [class.is-warning]="isWarning(error)">{{ typeLabel(error) }}</span>
          </td>
          <td class="col-cell">
            <ng-container *ngIf="getCellLabel(error) as label; else noCell">
              <span class="validation-error-cell-link" title="Click to navigate to this cell in the workbook">{{ label }}</span>
            </ng-container>
            <ng-template #noCell>
              <span class="validation-error-cell-empty">—</span>
            </ng-template>
          </td>
          <td class="col-message">
            <span class="validation-error-body-text" [title]="getTooltipText(error)">{{ displayErrorBodyText(error) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="validation-error-status validation-error-status--success" *ngIf="isAllChecksPassed">
    <div class="validation-error-status-icon-wrap">
      <mat-icon class="validation-error-status-icon">check_circle</mat-icon>
    </div>
    <p class="validation-error-status-title">All checks passed</p>
    <p class="validation-error-status-sub">This form passed all validation rules and is ready to submit.</p>
  </div>
</ng-template>
